import $ from 'jquery';

import App from '@components/App';
import {animated_dots} from "../utils/legacy-functions";

class Validator {
    constructor(fields) {
        this.fields = fields;
        this.isValid = true;
        this.top = 0;
    }

    closure(closure, element) {
        return closure(element);
    }

    regex(value, pattern) {
        let regex = new RegExp(pattern)
        return regex.test(value);
    }

    notEmpty(value) {
        return value !== '';
    }

    checkElement(index) {
        let elementSelector = this.fields[index]['selector'];
        let element = $(elementSelector);
        let elementValue = element.val();
        let options = this.fields[index];
        let isValidElement = true;
        let that = this;
        Object.keys(options.validators).forEach(function (validator) {
            let validatorValue = options.validators[validator];
            switch (validator) {
                case 'notEmpty':
                    if (validatorValue === true && !that.notEmpty(elementValue)) {
                        isValidElement = false;
                    }
                    break;
                case 'regex':
                    if (!that.regex(elementValue, validatorValue)) {
                        isValidElement = false;
                    }
                    break;
                case 'validate':
                    if (!that.closure(validatorValue, element)) {
                        isValidElement = false;
                    }
            }
        });
        if (!isValidElement) {
            element.parents(options.parentElement).addClass(options.errorClass);
            if (this.isValid) {
                this.isValid = false;
            }
            let top = element.parents(options.scroll).offset().top;
            if(this.top === 0 || this.top > top){
                this.top = top;
            }
        }
    }

    validate() {
        for (let index = 0; index < this.fields.length; index++) {
            this.checkElement(index)
        }
        if(this.top > 0) {
            $("html, body").animate({scrollTop: this.top});
        }
        return this.isValid;
    }
}

class Complaint extends App {
    constructor() {
        super();
    }

    showSelectedOption(element) {
        if ($(element).val() === '') {
            $(element).prev().find('.text').css({'color': '#aaa'}).text($(element).find('option').first().text());
        } else {
            $(element).prev().find('.text').css({'color': '#000'}).text($(element).find('option:selected').text());
        }
    }

    getValidations() {
        return [
            {
                'selector': '#name',
                'parentElement': '.cinput',
                'errorClass': 'wrong',
                'scroll' : '.form-group',
                'validators': {
                    'notEmpty': true,
                    'regex': /[a-zA-Z]/
                }
            },
            {
                'selector': '#surname',
                'parentElement': '.cinput',
                'errorClass': 'wrong',
                'scroll' : '.form-group',
                'validators': {
                    'notEmpty': true,
                    'regex': /[a-zA-Z]/
                }
            },
            {
                'selector': '#person-id-number',
                'parentElement': '.cinput',
                'errorClass': 'wrong',
                'scroll' : '.form-group',
                'validators': {
                    'notEmpty': true,
                }
            },
            {
                'selector': '#phone',
                'parentElement': '.cinput',
                'errorClass': 'wrong',
                'scroll' : '.form-group',
                'validators': {
                    'notEmpty': true,
                    'regex': /^(77|76|75|95|96|97|)\d{1}\s[0-9]{3}\s[0-9]{3}$/
                }
            },
            {
                'selector': '#descriptionOfComplaint',
                'parentElement': '.cinput',
                'errorClass': 'wrong',
                'scroll' : '.form-group',
                'validators': {
                    'notEmpty': true,
                }
            },
            {
                'selector': '#email',
                'parentElement': '.cinput',
                'errorClass': 'wrong',
                'scroll' : '.form-group',
                'validators': {
                    'notEmpty': true,
                    'regex': /^\S+@\S+$/
                }
            },
            {
                'selector': '#acceptTerms',
                'parentElement': '.checkbox-line',
                'errorClass': 'wrong',
                'scroll' : '#termsSection',
                'validators': {
                    'validate': function (element) {
                        return $(element).is(':checked');
                    },
                }
            },
        ]

    }

    bindEvents() {
        let that = this;
        $(() => {
            $('#email').on('keyup keypress blur', function () {
                $(this).val($(this).val().toLowerCase());
            })
                .mask("A", {
                    translation: {
                        "A": {pattern: /[\w@\-.+]/, recursive: true}
                    }
                });
            $('#phone').mask("000 000 000");
            $('#surname').mask("SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS");
            var options = {
                translation: {
                    'S': {
                        pattern: /[A-Za-z \' ]/
                    },
                }
            };
            $('#name').mask("SSSSSSSSSSSSSSSSSSSSSSSSSSSSSS", options);
            let attachDocumentSelector = '.attach-document .file';
            $(document).on('change', attachDocumentSelector, function () {
                $(this).parents('.form-group').removeClass('error-section');
                if ($(attachDocumentSelector).last()[0] === $(this)[0]) {
                    let template = $('#file_row_tpl').data('template');
                    template = template.replace(/__index__/g, $('.attach-document').length);
                    $('#documents').append(template);
                }
            });

            $('select').each((key, element) => {
                that.showSelectedOption(element);
            });

            $(document).on('change', 'select', function () {
                that.showSelectedOption(this);
            });

            $('#complaint_form').on('submit', function (e) {
                let validator = new Validator(that.getValidations());
                if (!validator.validate()) {
                    e.preventDefault();
                } else {
                    let button = $('#complaint-form-button');
                    button.attr('disabled', 'disabled');
                    let waitText = button.data('wait_text');
                    button.addClass('disabled').text(waitText).append($('<span class="animated_dots"></span>'));
                    animated_dots();
                }
            });

        });
    }

    init() {
        ENV === 'development' && console.log('Complaint::init()');

        this.bindEvents();

        super.init();
    }
}

export default Complaint;
